var exports = {
  "A": "x804f0401--025376--item",
};

module.exports = exports;
